import { createMuiTheme } from '@material-ui/core/styles';
import WebFont from 'webfontloader';
import * as variables from '~/styles/variables.scss';

// A theme with custom primary and secondary color.
// It's optional.
export const MUIAppTheme = createMuiTheme({
    palette: {
        primary: {
            light: variables.colorOrangeLight,
            main: variables.colorOrange,
            dark: variables.colorOrangeDark,
            contrastText: '#fff',
        },
        secondary: {
            light: '#ff5e50',
            main: '#e41e26',
            dark: '#a90000',
            contrastText: '#fff',
        },
    },
    overrides: {
        MuiTypography: {
            h1: {
                fontFamily: 'var(--font-heading-large)',
                transform: 'scaleX(0.725)',
                textTransform: 'uppercase',
                color: 'var(--color-dark-text)',
            },
            h2: {
                fontFamily: 'var(--font-heading-large)',
                transform: 'scaleX(0.725)',
                textTransform: 'uppercase',
                color: 'var(--color-dark-text)',
            },
            h3: {
                fontFamily: 'var(--font-heading-large)',
                transform: 'scaleX(0.725)',
                textTransform: 'uppercase',
                color: 'var(--color-dark-text)',
            },
            h4: {
                fontFamily: 'var(--font-heading-large)',
                transform: 'scaleX(0.725)',
                textTransform: 'uppercase',
                color: 'var(--color-dark-text)',
            },
            body1: {
                fontFamily: 'var(--font-default)',
                color: 'var(--color-dark-text)',
            },
            root: {
                fontFamily: 'var(--font-default)',
                color: 'var(--color-dark-text)',
            },
        },
    },
});

const WebFontConfig = {
    custom: {
        families: ['Helvetica LT Std Bold Condensed', 'Helvetica Neue'],
        urls: ['./styles/fonts.css'],
    },
};

WebFont.load(WebFontConfig);
